document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("[data-lc-form]");
  const addButton = document.querySelector("[data-lc-add-to-cart]");
  const variantsScript = document.getElementById("lc-variants-json");

  if (!form || !addButton || !variantsScript) return;

  let variants = [];
  let isAdding = false;

  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (error) {
    console.error("LC JSON varianti non valido:", error);
    return;
  }

  function findVariantBySphere(sphereValue) {
    if (!sphereValue) return null;

    return variants.find((variant) => variant.option1 === sphereValue) || null;
  }

  function getValue(id) {
    return document.getElementById(id)?.value?.trim() || "";
  }

  function getQty(id) {
    return parseInt(document.getElementById(id)?.value, 10) || 0;
  }

  async function refreshDrCartUi() {
    const cartResponse = await fetch("/cart.js", {
      headers: {
        Accept: "application/json"
      }
    });

    if (!cartResponse.ok) {
      throw new Error("Errore lettura carrello");
    }

    const cart = await cartResponse.json();

    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    const drawerContent = document.querySelector("#DrCartDrawerContent");

    if (drawerContent) {
      const drawerResponse = await fetch(window.location.pathname, {
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      if (!drawerResponse.ok) {
        throw new Error("Errore aggiornamento drawer");
      }

      const drawerHtml = await drawerResponse.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(drawerHtml, "text/html");

      const newDrawerContent = doc.querySelector("#DrCartDrawerContent");

      if (newDrawerContent) {
        drawerContent.innerHTML = newDrawerContent.innerHTML;

        if (typeof window.initDrCartDrawer === "function") {
          window.initDrCartDrawer();
        }
      }
    }

    if (typeof window.openDrCartDrawer === "function") {
      window.openDrCartDrawer();
    }
  }

  async function handleAddToCart() {
    if (isAdding) return;
    isAdding = true;

    const originalText = addButton.textContent.trim();

    const odSphere = getValue("od-sfera");
    const osSphere = getValue("os-sfera");

    const odQty = getQty("od-qty");
    const osQty = getQty("os-qty");

    const odCilindro = getValue("od-cilindro");
    const osCilindro = getValue("os-cilindro");

    const odAsse = getValue("od-asse");
    const osAsse = getValue("os-asse");

    const odBc = getValue("od-bc") || getValue("lc-default-bc");
    const osBc = getValue("os-bc") || getValue("lc-default-bc");

    const odDia = getValue("od-dia") || getValue("lc-default-dia");
    const osDia = getValue("os-dia") || getValue("lc-default-dia");

    const odAdd = getValue("od-add") || getValue("lc-default-add");
    const osAdd = getValue("os-add") || getValue("lc-default-add");

    if (odQty === 0 && osQty === 0) {
      alert("Seleziona almeno una quantità per OD o OS.");
      isAdding = false;
      return;
    }

    const items = [];

    if (odQty > 0) {
      if (!odSphere) {
        alert("Seleziona la Sfera per OD.");
        isAdding = false;
        return;
      }

      const odVariant = findVariantBySphere(odSphere);

      if (!odVariant) {
        alert("Non trovo la variante corretta per OD: " + odSphere);
        isAdding = false;
        return;
      }

      items.push({
        id: odVariant.id,
        quantity: odQty,
        properties: {
          Occhio: "OD",
          Sfera: odSphere,
          ...(odCilindro && { Cilindro: odCilindro }),
          ...(odAsse && { Asse: odAsse }),
          ...(odBc && { BC: odBc }),
          ...(odDia && { DIA: odDia }),
          ...(odAdd && { ADD: odAdd })
        }
      });
    }

    if (osQty > 0) {
      if (!osSphere) {
        alert("Seleziona la Sfera per OS.");
        isAdding = false;
        return;
      }

      const osVariant = findVariantBySphere(osSphere);

      if (!osVariant) {
        alert("Non trovo la variante corretta per OS: " + osSphere);
        isAdding = false;
        return;
      }

      items.push({
        id: osVariant.id,
        quantity: osQty,
        properties: {
          Occhio: "OS",
          Sfera: osSphere,
          ...(osCilindro && { Cilindro: osCilindro }),
          ...(osAsse && { Asse: osAsse }),
          ...(osBc && { BC: osBc }),
          ...(osDia && { DIA: osDia }),
          ...(osAdd && { ADD: osAdd })
        }
      });
    }

    if (!items.length) {
      alert("Nessun articolo da aggiungere al carrello.");
      isAdding = false;
      return;
    }

    try {
      addButton.disabled = true;
      addButton.textContent = "Aggiungo...";

      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ items })
      });

      if (!addResponse.ok) {
        const errorText = await addResponse.text();
        console.error("LC ADD ERROR RESPONSE:", errorText);
        throw new Error("Errore aggiunta al carrello");
      }


      // ===============================
      // GA4 — ADD TO CART LAC
      // ===============================
      await addResponse.json();

      const productName =
        document.querySelector(".lc-title")?.textContent?.trim() || "Lenti a contatto";

      const ga4Items = items.map((item) => {
        const variant = variants.find((variant) => String(variant.id) === String(item.id));

        return {
          item_id: String(variant?.product_id || item.id),
          item_variant: String(item.id),
          item_name: variant?.title || productName,
          price: Number(variant?.price || 0) / 100,
          quantity: item.quantity || 1
        };
      });

      const ga4Payload = {
        currency: "EUR",
        value: ga4Items.reduce((total, item) => total + item.price * item.quantity, 0),
        items: ga4Items
      };

      document.dispatchEvent(new CustomEvent("dr:add_to_cart", {
        detail: ga4Payload
      }));

       // ===============================
      // END GA4
      // ===============================

      await refreshDrCartUi();

      addButton.textContent = "Aggiunto";

      setTimeout(() => {
        addButton.disabled = false;
        addButton.textContent = originalText || "Aggiungi al carrello";
        isAdding = false;
      }, 1200);

    } catch (error) {
      console.error("DR LC AJAX CART ERROR:", error);

      addButton.textContent = "Errore";

      setTimeout(() => {
        addButton.disabled = false;
        addButton.textContent = originalText || "Aggiungi al carrello";
        isAdding = false;
      }, 1200);
    }
  }

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    handleAddToCart();
  });
});